import { Settings } from "@templates/index"

import AppAppearanceSelector from "./components/AppAppearanceSelector/AppAppearanceSelector"

export default function SettingsPreferences() {
    return (
        <Settings.Wrapper title="Preferences">
            <Settings.PageContainer>
                <Settings.PageHeader
                    variant="page-heading"
                    title="Preferences"
                    subtitle="Manage your application preferences."
                    infoMessage="These preferences only apply to you."
                />

                <Settings.Divider />

                <Settings.Section>
                    <Settings.PageHeader
                        variant="section-heading"
                        title="Appearance"
                        subtitle="Choose your desired Roopairs interface."
                    />
                    <AppAppearanceSelector />
                </Settings.Section>
            </Settings.PageContainer>
        </Settings.Wrapper>
    )
}
